<script setup>
import { computed, onMounted, ref } from 'vue'
import RecentList from '@components/search/recentList'
import DataLayer from '@services/data-layer/index'
import recentSearchService from '@services/search/recent-search-service'

const REQUEST_TYPES = {
    artist: 'artists',
    mix: 'mixes',
    show: 'shows',
}

const recentData = ref([])

const orderedRecentData = computed(() => [...recentData.value].sort((a, b) => b.order - a.order))

function getRecentData() {
    recentSearchService.getRecent().forEach((item, order) => {
        if (!item.itemId) return

        if (item.type === 'genre') {
            recentData.value.push({
                title: item.itemId.replace(/_/g, ' '),
                type: 'genre',
                order,
            })
            return
        }

        DataLayer[REQUEST_TYPES[item.type]].getById(item.itemId).then(data => {
            data.body.type = item.type
            data.body.order = order
            recentData.value.push(data.body)
        })
    })
}

function clearRecentSearch() {
    recentSearchService.clearRecent()
    recentData.value = []
}

onMounted(getRecentData)
</script>

<template>
    <BaseSection
        v-if="orderedRecentData && orderedRecentData.length"
        class="search-recent"
        padded
    >
        <h4>Recent Searches</h4>
        <RecentList :items="orderedRecentData" />
        <BaseButton
            :active="true"
            class="search-recent-button"
            button-type="secondary"
            @click="clearRecentSearch"
        >clear recent search</BaseButton>
    </BaseSection>
    <BaseSection
        v-else
        class="search-recent-waiting"
    >
        <BaseIcon
            class="search-recent-waiting-icon"
            name="search"
        />
        <div class="search-recent-waiting-head">Search Frisky</div>
        <div class="search-recent-waiting-sub">
            <span>Find music by artist, genre or show name</span>
        </div>
    </BaseSection>
</template>

<style lang="scss" scoped>
@import '@design';

.search-recent {
    @include desktop {
        margin: 0;
    }
}

.search-recent-button {
    text-transform: uppercase;
}

.search-recent-waiting {
    @include center;

    top: 25%;
    width: 100%;
    text-align: center;

    &-icon {
        @include square(64px);
        @include iconStroke(64px);

        margin-bottom: $s-s;
        color: $c-white;
    }

    &-head {
        @extend %h4;

        margin-bottom: $s-xs;
    }

    &-sub {
        @extend %contentTinyHeading;
    }
}
</style>
